import { TableCell, TableHead, TableRow } from '@mui/material'

interface HeadCell {
  id: string
  label: string
}

interface EnhancedTableHeaderProps {
  headCells: HeadCell[]
}

const EnhancedTableHeader = ({ headCells }: EnhancedTableHeaderProps) => (
  <TableHead>
    <TableRow>
      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          align="left"
          sx={{
            fontWeight: 600,
            color: 'text.secondary',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          {headCell.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
)

export default EnhancedTableHeader
